export const WAYPOINT_ACCESS_TYPE_PUBLIC = 'public'
export const WAYPOINT_ACCESS_TYPE_PRIVATE = 'private'

export const WAYPOINT_ACCESS_TYPE_ICONS = {
  [WAYPOINT_ACCESS_TYPE_PUBLIC]: { type: 'is-success', icon: 'unlock' },
  [WAYPOINT_ACCESS_TYPE_PRIVATE]: { type: 'is-danger', icon: 'lock' },
}
